<div class="container-xxxl t-and-c-section">
    <div mat-dialog-title class="mb-0 pb-0">
        <div class="float-start">
            <span class="heading font-family-montserrat">Terms & Conditions</span>
        </div>
        <div class="float-end">
            <i mat-dialog-close class="fa fa-times" aria-hidden="true"></i>
        </div>
    </div>
    <div mat-dialog-content>
        <!-- Moved Cards Section -->
        <div class="row">
            
            <div class="mt-3 mb-4">
                <app-selected-course-card [assessment]="data.assessment"></app-selected-course-card>
            </div>

            <!-- Card -->
            <div class="col-12 font-family-montserrat">
                <p class="title">Terms & Conditions</p>
                <ol>
                    <li>Learners must have successfully completed Class 12 (Higher Secondary/Equivalent) to be eligible for enrollment.</li>
                    <li>Course fees must be paid in full at the time of enrollment. All purchases are final and non-refundable.</li>
                    <li>Learners have access to the online course materials for eight (8) weeks, starting from the time they first launch the course through the LMS. After this period, access will expire automatically.</li>
                    <li>All course materials are provided for online viewing only through the learning platform. Downloading, copying, recording, or redistributing course content in any form is strictly prohibited.</li>
                    <li>Course materials are for the personal educational use of the enrolled learner only and may not be transferred, sublicensed, or shared with others.</li>
                    <li>Learners are required to maintain their own login credentials securely. Account sharing is not permitted.</li>
                    <li>Certificates will be issued only upon successful completion of all required assessments within the validity period.</li>
                    <li>No certificate will be awarded for partial completion, non-completion, or failure to meet assessment requirements.</li>
                    <li>The issuing institute reserves the right to review and verify assessment submissions to ensure academic integrity. Any attempt at plagiarism, impersonation, or dishonest conduct may lead to suspension of access and cancellation of certification without refund.</li>
                    <li>Completion of a course does not, by itself, guarantee employment, admission to a degree programme, or credit transfer.</li>
                    <li>The institute reserves the right to update, revise, or improve course content, assessment requirements, or Term & Conditions at any time without prior notice.</li>
                </ol>
                <div class="checkbox-section">
                    <mat-checkbox [(ngModel)]="isSelected" tabindex="-1">
                        <span class="checkbox-text">I have read the Terms & Conditions and I accept the same.</span>
                    </mat-checkbox>
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="px-4">
        <!-- Cancel Button (Visible only on mobile) -->
        <button (click)="proceedToLevelSelection(data.buyAction)" mat-dialog-close class="btn-proceed" mat-button color="primary" [disabled]="!isSelected">
            <span>Continue to Checkout</span>
            <i class="fa fa-arrow-right ms-2" aria-hidden="true"></i>
        </button>
    </div>